import React from 'react';
import Chart from 'chart.js';
import { calcTransportCosts } from '../dailytrips/calc_costs';

export default class ChartCosts extends React.Component {
	constructor(props) {
		super(props);
		this.costs = calcTransportCosts("1")
		this.costs2 = calcTransportCosts("2")
		this.chart = null

	}
	componentDidMount () {
		var ctx = document.getElementById("chart-compare");
		var data = {
			    labels: [
			        "Wohnstandort 1",
			        "Wohnstandort 2"
			    ],
			    datasets: [
			        {	
			            label: 'Wohnkosten',
			        	data: [this.costs[2], this.costs2[2]],
			            backgroundColor: "#e0e0e0",
			            hoverBackgroundColor: "#e0e0e0"
			        },
			        {	
			            label: 'Kosten für PKWs inkl. Kraftstoff',
			            data: [this.costs[0], this.costs2[0]],
			            backgroundColor: "#d8d4a6",
			            hoverBackgroundColor: "#d8d4a6"
			        },
			        {	
			            label: 'Kosten für ÖV',
			            data: [this.costs[1], this.costs2[1]],
			            backgroundColor: "#dff0d8",
			            hoverBackgroundColor: "#dff0d8"
			        }
			        ]
			};
		
		var options = {
				defaultFontFamily: Chart.defaults.global.defaultFontFamily = "'Open Sans'",
//				defaultFontColor: Chart.defaults.global.defaultFontColor = "'#000000'",
				scales: {
		            xAxes: [{
		              stacked: true,
		              ticks: {
		                    beginAtZero:true
		                }
		            }],
		            yAxes: [{
		              stacked: true,
		              ticks: {
		                    beginAtZero:true
		                }
		            }]
		          }
		        };
		
		this.chart = new Chart(ctx, {
		    type: 'bar',
		    data: data,
		    options: options
		});
	}
	render () {
	return (
<div className="panel panel-default">
    <div className="panel-body compare-chart-container text-right">
        <canvas id="chart-compare" width="300" height="400"/>
    </div>
</div>
	)
	}
}




// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/results/comparison_chart.js